import React from "react";
import ReactFocusTrap from "focus-trap-react";
type FocusTrapProps = React.PropsWithChildren<{
  active?: boolean;
}>;

/**
 * Common configuration of the focus-trap-react component
 *
 * We need to set tabbableOptions.displayCheck to "none" in order for jest testing
 * to run properly. See https://www.npmjs.com/package/focus-trap-react#testing-in-jsdom
 */
export function FocusTrap({
  active = true,
  children
}: FocusTrapProps) {
  return <ReactFocusTrap active={active} focusTrapOptions={{
    tabbableOptions: {
      displayCheck: "none"
    }
  }} data-sentry-element="ReactFocusTrap" data-sentry-component="FocusTrap" data-sentry-source-file="FocusTrap.tsx">
      {children}
    </ReactFocusTrap>;
}
export default FocusTrap;